// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-toggler {
    border: none !important;
}

.navbar-toggler-bar {
    background: #222 !important; /* Warna lebih gelap */
    height: 3px !important;       /* Biar lebih tebal */
    width: 25px !important;
    margin: 4px 0 !important;
    border-radius: 2px;
    display: block;
}

.navbar-toggler:hover .navbar-toggler-bar {
    background: #000 !important; /* lebih bold saat hover */
}

.navbar-info .navbar-toggler {
    filter: drop-shadow(0 0 3px rgba(0,0,0,0.5)); /* Tambah glow biar makin terlihat */
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbars/navbar.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B,EAAE,sBAAsB;IACnD,sBAAsB,QAAQ,qBAAqB;IACnD,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B,EAAE,0BAA0B;AAC3D;;AAEA;IACI,4CAA4C,EAAE,oCAAoC;AACtF","sourcesContent":[".navbar-toggler {\n    border: none !important;\n}\n\n.navbar-toggler-bar {\n    background: #222 !important; /* Warna lebih gelap */\n    height: 3px !important;       /* Biar lebih tebal */\n    width: 25px !important;\n    margin: 4px 0 !important;\n    border-radius: 2px;\n    display: block;\n}\n\n.navbar-toggler:hover .navbar-toggler-bar {\n    background: #000 !important; /* lebih bold saat hover */\n}\n\n.navbar-info .navbar-toggler {\n    filter: drop-shadow(0 0 3px rgba(0,0,0,0.5)); /* Tambah glow biar makin terlihat */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
